import styled, { css } from '@xstyled/styled-components';

export interface CapsuleProps {
  highlighted?: boolean;
}

export const Capsule = styled.spanBox<CapsuleProps>`
  width: 26px;
  min-width: 26px;
  height: 26px;
  min-height: 26px;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    max-width: 16px;
    max-height: 16px;
  }
  ${p =>
    p.highlighted
      ? css`
          background: ${p => p.theme.colors.accentDark};
          color: var(--color-on-accent);
          /* Locked capsules use greyDark border; accent-edge is often
             transparent, so outline with on-accent for dark/light brands. */
          border: 1px solid
            color-mix(in srgb, var(--color-on-accent) 45%, transparent);
          > svg {
            fill: var(--color-on-accent);
            stroke: var(--color-on-accent);
          }
        `
      : css`
          /* CAT-1241 / WCAG 1.4.11: non-text contrast is stroke vs surface.
             greyMed fill (#e0e0e0) vs white was 1.32:1 — tools treat that as
             the control edge. Hollow + greyDark stroke (#6f6f6f / dark #efefef)
             passes vs white and vs row hover (#fafafa / dark grey-lt). */
          background: transparent;
          color: ${p => p.theme.colors.black};
          border: 1px solid ${p => p.theme.colors.greyDark};
          box-sizing: border-box;
          > svg {
            fill: ${p => p.theme.colors.black};
            stroke: ${p => p.theme.colors.black};
          }
        `};
`;
